/**
 * LocalRuleNote — a one-sentence note under the field a known local ordinance touches
 * (security deposit, late fees, notice to end a tenancy, required disclosures). Renders only
 * for KNOWN_UNMODELED coverage that cites the category. Never blocks anything.
 */

import { Info } from 'lucide-react';
import type { JurisdictionCoverage } from '@resida/api-types/lease-generation';
import { localRuleNote, type LocalOrdinanceCategory } from '../lib/jurisdiction-coverage';

export interface LocalRuleNoteProps {
  coverage: JurisdictionCoverage | null | undefined;
  category: LocalOrdinanceCategory;
}

export function LocalRuleNote({ coverage, category }: LocalRuleNoteProps) {
  if (!coverage) return null;
  const copy = localRuleNote(coverage, category);
  if (!copy) return null;

  return (
    <p
      data-testid="local-rule-note"
      data-category={category}
      className="m-0 mt-1 flex items-start gap-1.5 text-sm text-foreground"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-info" aria-hidden="true" />
      <span className="min-w-0">{copy}</span>
    </p>
  );
}
